<template>
  <div class="logistic">

    <div class="l-box" v-if="logistic.length !== 0">
      <ul>
        <li v-for="item of logistic" :key="item.sn" @click="show(item.sn)">
          <div>{{item.com}}</div>
          <div>单号: {{item.sn}}</div>
          <div>备注: {{item.remarks}}</div>
        </li>
      </ul>
    </div>
    <!-- :image="require('../../assets/icon/logistics.png')" -->
    <van-empty v-if="logistic.length === 0" class="custom-image" description="暂无物流记录" />

    <van-popup v-model="visible" close-icon-position="top-right" :ock-scroll="false" closeable style="height: 90vh; width: 95vw;">

      <div class="content">
        <van-steps :active="active" direction="vertical">

          <van-step v-for="(item,index) of logisticDateil" :key="index">
            <div> {{item.operation}} {{item.content}}</div>
            <div>{{item.time}}</div>
          </van-step>
        </van-steps>
      </div>

    </van-popup>
  </div>
</template>
<script>
import { getOrderLogistics } from '@/api/user'

import scroll from '@/mixins/scroll'
export default {
  name: 'logistic',
  data () {
    return {
      logistic: [],
      visible: false,
      logisticDateil: [],
      active: 0,
      isEmptyLogistic: false

    }
  },
  mixins: [scroll],
  methods: {
    show (sn) {
      this.logistic.map(item => {
        if (item.sn === sn) this.logisticDateil = item.data
      })
      this.visible = true
    },
    async getList () {
      const order_sn = this.$route.query.id
      const result = await getOrderLogistics({
        order_sn,
        page: this.page,
        size: 15
      })
      try {
        if (result.data.data.logistics.length !== 0) {
          this.isEmptyLogistic = true
          this.logistic = this.logistic.concat(result.data.data.logistics)
        } else {
          this.page = null
        }
      } catch (err) { }
    },
  }
}
</script>
<style lang="scss" scoped>
.logistic {
  font-size: 0.28rem;
  .l-box {
    ul {
      width: 90vw;
      margin: auto;
      li {
        padding: 0.2rem;
        background: #fff;
        margin: 0.2rem auto;
        border-radius: 10px;
      }
    }
  }
  .content {
    margin-top: 1rem;
    // width: 90vh;
    height: 70vh;
    width: 99%;
    overflow-y: scroll;
  }
}
</style>>